<div *ngIf="player" class="playerInfoSection">
  <div class="playerImageContainer">
    <img [src]="player.image" alt="name" class="playerImageSize"/>
  </div>
  <p>
    <a
      class="fs16 fc-main mt-2 nameLink"
      (click)="openDuelPlayerDetails($event)"
    >
      {{ player.full_name }}
    </a>
  </p>
  <div class="fs12 mt--15">
    <span *ngIf="player.birthdate"
      >{{ player.birthdate | amDateFormat: "YYYY"
      }}{{ player.title ? "," : "" }}
    </span>
    <span *ngIf="player.title">{{ player.title }}</span>
    <div *ngIf="player.country">
      <span
        class="fi fi-{{ player.country_code }}"
        *ngIf="player.country_code"
      ></span>
      {{ player.country }}
    </div>
    <div *ngIf="player.city">{{ player.city }}</div>
    <div *ngIf="player.team">
      <div class="TeamMembers" *ngFor="let member of player.team">{{ member }}</div>
    </div>
  </div>
</div>
<div *ngIf="!player && hasWalkOver()">
  <p class="fs16 fc-main mt-2">Walk Over</p>
</div>
